import { api } from '@web/api/client'

export const MAX_UPLOAD_BYTES = 4 * 1024 * 1024
export const MAX_MESSAGE_ATTACHMENT_BYTES = 8 * 1024 * 1024

/** Save the original bytes before making an attachment available to send. */
export async function uploadSessionFile(sessionId: string, file: File) {
  if (file.size > MAX_UPLOAD_BYTES)
    throw new Error(`${file.name} is larger than 4 MB`)
  const data = await readAsBase64(file)
  const upload = await api.uploadSessionFile(
    sessionId,
    {
      path: file.name || 'attached-file',
      mime_type: file.type || 'application/octet-stream',
      content_base64: data,
    },
    uploadKey(file),
  )
  return { upload, data }
}

const retryKeys = new WeakMap<File, string>()

/** Reuse a retry key when a failed request is retried with the same selected file. */
function uploadKey(file: File): string {
  let key = retryKeys.get(file)
  if (!key) {
    key = crypto.randomUUID()
    retryKeys.set(file, key)
  }
  return key
}

export function readAsBase64(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result).split(',', 2)[1] ?? '')
    reader.onerror = () =>
      reject(reader.error ?? new Error('The file could not be read.'))
    reader.readAsDataURL(file)
  })
}
